<script setup lang="ts">
  import {
    computed,
    nextTick,
    onActivated,
    onBeforeUnmount,
    onMounted,
    reactive,
    ref,
    watch,
  } from 'vue';
  import {
    actions as actionTypes,
    useUserComponent,
    useHelpers,
    createComponentScope,
    Resource,
    uniqueID,
  } from '@integro/core';
  import type { IAppHelpers } from '@integro/core';
  import * as _ from 'lodash';

  defineOptions({
    name: 'UcContractRevisionDropdownItem',
    inheritAttrs: false,
  });

  const componentMetadata = {
    kind: 'usercontrol',
  };

  const emit = defineEmits(['reload', 'close', 'save']);

  const props = defineProps({
    revisionInfo: {
      type: Object,
      required: true,
    },
    isSelected: {
      type: Boolean,
      required: false,
    },
  });

  const {
    $app,
    $fn,
    $i18n,
    $store,
    $config,
    $imodal,
    $notification,
    $tabs,
    $route,
    $router,
    gettext,
    pgettext,
    ngettext,
    npgettext,
    schemaDefaults,
    getSchema,
    searchDataSource,
    randomElementId,
    datetime,
    date,
    time,
    number,
    money,
    distance,
    username,
    filesize,
  } = useHelpers();

  const ux = ref([]);
  const b_2248226175642056_class = computed(() => ({
    'font-wwight-bold': props.isSelected,
  }));
  const b_3343864469950044_style = computed(() => ({
    width: '80px',
  }));

  const $data = computed(() => ({
    ux: ux.value,
    b_2248226175642056_class: b_2248226175642056_class.value,
    b_3343864469950044_style: b_3343864469950044_style.value,
  }));

  const {
    loading,
    error,
    loaded,
    reloading,
    showLoadingIndicator,
    loadDataThrottled,
    friendlyName,
    loadData,
    touchLastLoaded,
    handleError,
    setData,
    forms,
    registerForm,
    unregisterForm,
    canLoadData,
    isModalComponent,
    modalName,
    pageDocument: _pageDocument,
    routeTab,
    ux: _ux,
    componentMetadata: _componentMetadata,
    $uid,
    lastLoaded,
  } = useUserComponent(props, {
    metadata: componentMetadata,
    dataSpecs: [
      { name: 'ux' },
      { name: 'b_2248226175642056_class', nodeId: '2248226175642056' },
      { name: 'b_3343864469950044_style', nodeId: '3343864469950044' },
    ],
    loaders: {},
    ux: {},
    dataRefs: { ux, b_2248226175642056_class, b_3343864469950044_style },
  });

  const $component = createComponentScope(
    {
      $app,
      $fn,
      $i18n,
      $store,
      $imodal,
      $notification,
      $tabs,
      $router,
    } as IAppHelpers,
    {
      emit,
      forms,
      error,
      isModalComponent,
      modalName,
      componentMetadata,
      loadData,
      registerForm,
      unregisterForm,
      setData,
      touchLastLoaded,
      handleError,
    }
  );

  watch(
    () => props.revisionInfo,
    (newValue, oldValue) => {
      if (_.isEqual(newValue, oldValue)) return;
      loadDataThrottled('revisionInfo');
    }
  );
  watch(
    () => props.isSelected,
    (newValue, oldValue) => {
      if (_.isEqual(newValue, oldValue)) return;
      loadDataThrottled('isSelected');
    }
  );

  const actions = {};

  defineExpose({
    loadData,
    loading,
    loaded,
    error,
  });
</script>

<template>
  <div class="d-inline-block">
    <ItpBox alignItems="center" :class="b_2248226175642056_class">
      <ItpText :text="revisionInfo.revision_number" class="px-2"> </ItpText>
      <div class="mx-2 text-center" :style="b_3343864469950044_style">
        <UcContractStatusBadge :value="revisionInfo.status">
        </UcContractStatusBadge>
      </div>
      <ItpText :text="date(revisionInfo.revision_date)" class="mx-2"> </ItpText>
      <UcValidityPeriod
        :from="revisionInfo.valid_from"
        :to="revisionInfo.valid_to"
        class="px-2 border-start"
        v-if="revisionInfo.valid_from || revisionInfo.valid_to"
      >
      </UcValidityPeriod>
      <ItpText
        :text="revisionInfo.description"
        class="px-2 border-start"
        v-if="revisionInfo.description"
      >
      </ItpText>
    </ItpBox>
  </div>
</template>
